export const FEATURES = {
  BLOG: 'BLOG',
  MEDICAL_RECORDS: 'MEDICAL_RECORDS',
  MEDICATION: 'MEDICATION',
  SHOP: 'SHOP',
  EMERGENCY_CALL: 'EMERGENCY_CALL',
  HEALTH_MONITOR: 'HEALTH_MONITOR',
  ALERTS: 'ALERTS',
  DAILY_CHECKIN: 'DAILY_CHECKIN',
  AI_CHAT: 'AI_CHAT',
  AI_ENGINE: 'AI_ENGINE',
  AI_NUTRITION: 'AI_NUTRITION',
};

export const FEATURE_LABELS = {
  BLOG: 'Bài viết',
  MEDICAL_RECORDS: 'Hồ sơ khám bệnh',
  MEDICATION: 'Lịch uống thuốc',
  SHOP: 'Cửa hàng',
  EMERGENCY_CALL: 'Gọi khẩn cấp',
  HEALTH_MONITOR: 'Theo dõi chỉ số sức khỏe',
  ALERTS: 'Thông báo & cảnh báo',
  DAILY_CHECKIN: 'Điểm danh sinh tồn',
  AI_CHAT: 'Trợ lý AI',
  AI_ENGINE: 'AI rủi ro & gợi ý',
  AI_NUTRITION: 'AI tư vấn dinh dưỡng',
};

export const BASIC_FEATURES = [
  FEATURES.MEDICAL_RECORDS,
  FEATURES.MEDICATION,
  FEATURES.SHOP,
  FEATURES.EMERGENCY_CALL,
  FEATURES.HEALTH_MONITOR,
  FEATURES.ALERTS,
];

export const PREMIUM_FEATURES = [
  FEATURES.DAILY_CHECKIN,
  FEATURES.AI_CHAT,
  FEATURES.AI_ENGINE,
  FEATURES.AI_NUTRITION,
];

export function hasFeature(access, featureKey) {
  return Boolean(access?.features?.[featureKey]);
}
